/**
 * Support page: Predictive Search (articles only) + filter to one blog by URL path.
 * @see https://shopify.dev/docs/api/ajax/reference/predictive-search
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 280;
  var MIN_QUERY_LEN = 2;

  function getConfig(root) {
    var el = root.closest('[data-support-article-search]');
    if (!el) return null;
    var searchJsonUrl = el.getAttribute('data-search-json-url') || '';
    var rootPath = el.getAttribute('data-routes-root') || '/';
    if (!searchJsonUrl) {
      searchJsonUrl = rootPath.replace(/\/?$/, '/') + 'search/suggest.json';
    }
    return {
      blogHandle: el.getAttribute('data-blog-handle') || 'support',
      limit: parseInt(el.getAttribute('data-result-limit') || '10', 10),
      suggestJsonUrl: searchJsonUrl,
    };
  }

  function articlePathMatchesBlog(url, blogHandle) {
    if (!url || !blogHandle) return false;
    try {
      var pathname = new URL(url, window.location.origin).pathname;
      var marker = '/blogs/' + blogHandle + '/';
      return pathname.indexOf(marker) !== -1;
    } catch (e) {
      return url.indexOf('/blogs/' + blogHandle + '/') !== -1;
    }
  }

  function buildSuggestQuery(query, limit) {
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'article');
    params.set('resources[limit]', String(Math.min(Math.max(limit, 1), 10)));
    params.set('resources[limit_scope]', 'all');
    params.set('resources[options][fields]', 'title,body,tag,author');
    return params.toString();
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function init(root) {
    var cfg = getConfig(root);
    if (!cfg) return;

    var input = root.querySelector('[data-support-search-input]');
    var panel = root.querySelector('[data-support-search-results]');
    var status = root.querySelector('[data-support-search-status]');
    var debounceTimer;

    if (!input || !panel) return;

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      if (isError) status.setAttribute('role', 'alert');
      else status.removeAttribute('role');
    }

    function closePanel() {
      panel.hidden = true;
      panel.innerHTML = '';
      setStatus('');
    }

    function renderArticles(articles) {
      panel.innerHTML = '';
      if (!articles.length) {
        setStatus('');
        var empty = document.createElement('p');
        empty.className = 'support-article-search__empty';
        empty.textContent =
          'No matching support articles yet. Try different words or browse the topics below.';
        panel.appendChild(empty);
        panel.hidden = false;
        return;
      }

      var ul = document.createElement('ul');
      ul.className = 'support-article-search__list';
      ul.setAttribute('role', 'listbox');

      articles.forEach(function (article) {
        var li = document.createElement('li');
        li.className = 'support-article-search__item';
        li.setAttribute('role', 'option');
        var a = document.createElement('a');
        a.href = article.url.split('?')[0];
        a.className = 'support-article-search__link';
        a.textContent = article.title;
        li.appendChild(a);
        ul.appendChild(li);
      });

      panel.appendChild(ul);
      panel.hidden = false;
      setStatus('');
    }

    function runSearch(q) {
      var trimmed = q.trim();
      if (trimmed.length < MIN_QUERY_LEN) {
        closePanel();
        return;
      }

      setStatus('Searching…');
      panel.hidden = false;
      panel.innerHTML = '';

      var url =
        cfg.suggestJsonUrl +
        (cfg.suggestJsonUrl.indexOf('?') === -1 ? '?' : '&') +
        buildSuggestQuery(trimmed, cfg.limit);

      fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (res) {
          if (res.status === 429) {
            throw new Error('Too many requests. Please wait a moment.');
          }
          if (!res.ok) throw new Error('Search failed');
          return res.json();
        })
        .then(function (data) {
          var raw = (data.resources && data.resources.results && data.resources.results.articles) || [];
          var filtered = raw.filter(function (article) {
            return articlePathMatchesBlog(article.url, cfg.blogHandle);
          });
          renderArticles(filtered);
        })
        .catch(function (err) {
          setStatus(err.message || 'Something went wrong. Try again.', true);
          panel.hidden = false;
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var v = input.value;
      if (v.trim().length < MIN_QUERY_LEN) {
        closePanel();
        return;
      }
      debounceTimer = setTimeout(function () {
        runSearch(v);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_QUERY_LEN && panel.innerHTML === '') {
        runSearch(input.value);
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closePanel();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
  }

  document.querySelectorAll('[data-support-article-search]').forEach(init);
})();
